var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7937 8.90053C15.7937 13.3187 12.2581 16.9004 7.89697 16.9004C3.53585 16.9004 0 13.3187 0 8.90053C0 4.48231 3.53558 0.900391 7.89697 0.900391C12.2584 0.900391 15.7937 4.48231 15.7937 8.90053Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4566 8.90053C24.4566 13.0593 22.6888 16.432 20.5081 16.432C18.3275 16.432 16.5597 13.0593 16.5597 8.90053C16.5597 4.74173 18.3272 1.36902 20.5079 1.36902C22.6886 1.36902 24.4564 4.74065 24.4564 8.90053",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 8.90053C28 12.6258 27.3784 15.6476 26.6113 15.6476C25.8443 15.6476 25.2229 12.6266 25.2229 8.90053C25.2229 5.17445 25.8445 2.15348 26.6113 2.15348C27.3781 2.15348 28 5.17418 28 8.90053Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.60a4ffccec1b7cb8612033932ab73ea9.svg";
export { ForwardRef as ReactComponent };